@import 'styles/mixins';
@import 'styles/variables';

.container {
  margin-top: 32px;

  @include for-phone-only {
    margin-top: 0;
  }
}

.templatesGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;

  @include for-phone-only {
    grid-template-columns: repeat(1, 1fr);
  }
}

.header {
  margin-bottom: 16px;
  justify-content: space-between;
  display: flex;

  @include for-phone-only {
    display: unset;
  }
}

.section {
  margin-bottom: 16px;

  .sectionTitle {
    @include lg-semibold;
    color: var(--neutral-90);
  }
}

.mainButton {
  margin-bottom: 8px;
  width: 100%;
  max-width: 200px;
}

.errors {
  color: var(--negative-50);
}

.actions {
  margin-top: 12px;
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .right {
    column-gap: 8px;
    display: flex;
  }
}

@include for-phone-only {
  .buttons {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 24px 0;

    button {
      margin: 0 auto;
    }
  }
}
